import type { GlobalWidget, GlobalWidgetContext } from '@/app/widgets'

const chatUser = ({ signedIn, userType }: GlobalWidgetContext): boolean =>
  signedIn && (userType === 'Client' || userType === 'Staff' || userType === 'Freelancer')

/**
 * For every signed-in Client, Staff member or Freelancer, on every page:
 * - the presence heartbeat (API.md `POST presence`), so the chat can show who is online;
 * - the calls' ringing (`messages-calls`): it holds the chat's live connection — shared with the Messages page, one
 *   EventSource per tab — and shows the incoming-call card. Not in the call window, which holds the connection itself.
 */
const widgets: GlobalWidget[] = [
  {
    id: 'messages-presence',
    load: () => import('./components/PresenceHeartbeat.vue'),
    when: chatUser,
  },
  {
    id: 'messages-calls',
    load: () => import('./components/CallRinger.vue'),
    when: (context) => chatUser(context) && !context.path.startsWith('/messages/call/'),
  },
]

export default widgets
